import React from 'react'

const FinancialResources = () => {
  return (
    <div>
      Financial Resources
    </div>
  )
}

export default FinancialResources
